export interface Dependiente {
  idDependiente: number;
  idTrabajador: number;
  tipoDocumento: string | null;
  numeroDocumento: string | null;
  apellidoPaterno: string;
  apellidoMaterno: string | null;
  nombres: string;
  fechaNacimiento: string | null;
  parentesco: string;
  sexo: string | null;
  tieneDiscapacidad: boolean;
  esMenorEdad: boolean;
  esEstudiante: boolean;
  activo: boolean;
}

export const initialDependiente: Dependiente = {
  idDependiente: 0,
  idTrabajador: 0,
  tipoDocumento: '01',
  numeroDocumento: null,
  apellidoPaterno: '',
  apellidoMaterno: null,
  nombres: '',
  fechaNacimiento: null,
  parentesco: 'HIJO',
  sexo: null,
  tieneDiscapacidad: false,
  esMenorEdad: false,
  esEstudiante: false,
  activo: true,
};

export const PARENTESCOS = ['HIJO', 'CONYUGE', 'CONCUBINO', 'PADRE', 'MADRE', 'OTRO'];
